/**Dependencies */
import React from "react";

/**Components */

/**Images */
import openpay from "../images/openpay.png";

export const Terminos = () => {
  return (
    <div>
      <div className="container text-terminos py-0">
        <div className="w-100 d-grid justify-content-start py-4 text-nowrap">
          <h1
            className="text-lg-start text-start title-home destinos-inigualables"
            style={{ fontWeight: 700, letterSpacing: "3px" }}
          >
            TÉRMINOS Y CONDICIONES
          </h1>
        </div>
        <h4 className="text-rose">LICENCIA</h4>
        <p style={{ textAlign: "justify" }}>
          Por virtud de la celebración de este convenio, “AGENCIA MARZAH” otorga
          y concede al usuario el derecho no exclusivo, revocable y no
          transferible de ver y utilizar el sitio web{" "}
          <a href="https://marzahtravel.com">https://marzahtravel.com</a> de
          conformidad con los Términos y Condiciones de uso que aquí se
          estipulan. Para los efectos del presente convenio, las partes acuerdan
          que por «usuario» se entenderá a cualquier persona de cualquier
          naturaleza que ingrese al sitio web{" "}
          <a href="https://marzahtravel.com">https://marzahtravel.com</a> y/o a
          cualquiera de las subpáginas que despliegan su contenido y/o a la
          persona de cualquier naturaleza que se dé de alta y/o use cualquiera
          de los servicios que se ofrecen a través de dicha página.
        </p>
        <br />
        <h4 className="text-rose">CONDICIONES DEL SERVICIO</h4>
        <p style={{ textAlign: "justify" }}>
          <strong>Condiciones de Entrega</strong> <br />
          Una vez que el cliente cubra el anticipo o 100% del pago de su paquete
          vacacional recibirá vía correo electrónico el comprobante del mismo
          según sea el caso y clave de reservación que ampare su estancia en el
          hotel, destino y fecha seleccionada.
        </p>
        <p style={{ textAlign: "justify" }}>
          <strong>Condiciones del Hotel</strong> <br />
          Al confirmar la reserva, el cliente conoce y acepta que por motivos de
          los lineamientos oficiales derivados de la situación actual el hotel
          puede modificar y adaptar los horarios y servicios en función de las
          necesidades de cada momento. Así mismo el cliente se compromete a
          cumplir con las normas oficiales y reglamento interior del hotel en
          todo momento para cumplir con la normativa establecidos por la
          situación actual, dejando a la discrecionalidad de la dirección del
          Hotel la cancelación de la estancia en caso de incumplimiento. Así
          mismo el hotel puede hacer uso del derecho de admisión con base en los
          lineamientos oficiales.
        </p>
        <p style={{ textAlign: "justify" }}>
          <strong>Cambio de Fechas</strong> <br />
          El cliente podrá solicitar cambio de fechas, hotel o destino siempre y
          cuando notifique por escrito al correo: info@agenciamarzah.com con un
          mínimo de 30 días hábiles de antelación a la fecha de inicio del
          servicio y si aplica a su reservación. Es indispensable señalar que,
          en el caso de existir un cambio de tarifa con la nueva fecha, hotel o
          destino solicitado, esta diferencia deberá de ser cubierta por el
          cliente en su totalidad, al momento de realizar la actualización de
          fecha, destino u hotel para poder ser aceptada. ​Así como se quedan
          sujetos a los términos y condiciones con el operador/aerolínea/hotel
          con el cual que se haya ingresado a la reserva.
        </p>
        <p style={{ textAlign: "justify" }}>
          <strong>Devoluciones y/o Cancelaciones</strong> <br />
          El cliente podrá solicitar la devolución del importe pagado siempre y
          cuando la reserva se encuentre dentro de las condiciones para
          reembolso, y sea con un mínimo de 30 días antes de su entrada, así
          como, este 100% pagada (no hay reembolsos en sistemas de apartado), y
          siempre sujetándonos a los términos y condiciones, de la tarifa
          contratada, según el hotel y operador correspondiente, por lo que,
          deberá, notificar al correo: info@agenciamarzah.com con al menos 30
          días hábiles de antelación a la fecha de su llegada al hotel, en este
          caso el cliente podrá elegir según sus intereses aplicar el 100% de la
          devolución como crédito disponible a su favor para ser usado en su
          próximo viaje durante los próximos 12 meses posteriores a la fecha de
          solicitud o la cancelación del mismo bajo las siguientes condiciones:
          <ul>
            <li>
              Dar aviso por escrito al correo: info@agenciamarzah.com con al
              menos 30 días hábiles de antelación a su llegada al hotel
              seleccionado, en dicho caso habrá una penalización del 30% del
              importe pagado por gastos administrativos.
            </li>
            <li>
              Con 20 días hábiles de antelación con una penalidad de 50% de lo
              pagado.
            </li>
            <li>
              Con 15 días hábiles de antelación o menos con una penalidad del
              100% de lo pagado.
            </li>
          </ul>
          <strong>
            *ES IMPORTANTE SEÑALAR QUE SI LA RESERVACIÓN FUE HECHA DESDE SU
            INICIO CON UNA TARIFA PUBLICADA COMO “NO REEMBOLSABLE” EL CLIENTE
            ACEPTA QUE NO HAY CAMBIOS NI DEVOLUCIONES BAJO NINGUNA
            CIRCUNSTANCIA*
          </strong>
        </p>

        <br />
        <h4 className="text-rose">FORMAS DE PAGO</h4>
        <p style={{ textAlign: "justify" }}>
          Los pagos se procesan en un tiempo estimado de 24 horas después de su
          compra, por tal motivo, los pedidos que hayan sido pagados con tarjeta
          de crédito / débito y el Cliente decida recoger su cupón de servicios
          en nuestra oficina, se entregará después de 1 día hábil (indica un
          horario entre PTE), o en su caso se le enviará de manera electrónica.
          Para una mejor experiencia de compra con tarjeta de crédito en nuestra
          tienda en línea, el titular de la tarjeta deberá estar inscrito en los
          programas de compras seguras con 3D Secure para Visa y/o Master Card.
          <br />
          <br />
          <strong>
            *TARIFAS SUJETAS A CAMBIO Y DISPONIBILIDAD SIN PREVIO AVISO*
          </strong>
        </p>
        <br />
        <strong>Actualizado a Enero de 2025.</strong>
        <br />
        <br />
        <p style={{ fontSize: "20px", textAlign: "justify" }}>
          ¡Aceptamos todas las formas de pago! Efectivo, tarjetas de crédito y
          débito, transferencias y pagos digitales. ¡Elige la que te acomoda!
          <br />
          <br />
          Aceptamos todas las formas de pago. Su transacción se realiza de
          manera segura a través de Openpay, garantizando la confidencialidad y
          protección de sus datos.
        </p>
        <img src={openpay} width={300} alt="" />
      </div>
    </div>
  );
};
